import { defineMessages } from 'react-intl'

export default defineMessages({
  'successMsg': {
    id: 'successMsg',
    description: 'Operation success but still refreshing data',
    defaultMessage: 'Tests successfully ordered. Please wait as we process changes...',
  },
})
